import axios from "axios";
import { calculateKcalAndPercentage } from "../../../helpers/mealsHelper";
import i18n from "../../../i18n";
import { getClaims } from "../../../modules/login";
import {
  orderType,
  tablePageSizes,
} from "../../ui-library/CustomTable/constants";

// Constants
const LOADING_FAVORITE_MEALS = "LOADING_FAVORITE_MEALS";
const SET_FAVORITE_MEALS = "SET_FAVORITE_MEALS";
const RESET_STATE = "RESET_STATE";
const LOGOUT = "LOGOUT";

// Acessors
const getFavoriteMeals = (state) => state?.favoriteMeals;
const getTotalItems = (state) => state?.totalItems;
const getSearchedParams = (state) => state?.searchedParams;
const getLoading = (state) => state?.loading;

const canEditFavorites = (state) => getClaims(state, "favorites.canEdit");
const canViewDetailFavorites = (state) =>
  getClaims(state, "favorites.detail.canView");
const canCreateFavorites = (state) => getClaims(state, "favorites.canCreate");

// Default state
const initialState = {
  favoriteMeals: [],
  totalItems: null,
  loading: false,
  searchedParams: {
    page: 0,
    limit: tablePageSizes[0],
    search: "",
    orderBy: "date",
    order: orderType.DESC,
  },
};

export const favoritesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING_FAVORITE_MEALS:
      return {
        ...state,
        loading: true,
      };
    case SET_FAVORITE_MEALS:
      const { meals, records } = action;
      return {
        ...state,
        favoriteMeals: meals,
        totalItems: records,
        searchedParams: action.searchedParams,
        loading: false,
      };
    case RESET_STATE:
      return initialState;
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

const fetchFavoriteMeals = (searchedParams) => (dispatch) => {
  const params = {
    ...searchedParams,
  };

  dispatch({
    type: LOADING_FAVORITE_MEALS,
  });

  return axios
    .get(`/api/diet/meals/favorites`, { params })
    .then(({ data }) => {
      dispatch({
        type: SET_FAVORITE_MEALS,
        meals: parseTableData(data.data),
        records: data.records,
        searchedParams,
      });
    })
    .catch(() => {
      return Promise.reject(i18n.t("errorText.dietDiary.favorites.get"));
    });
};

const parseTableData = (data) => {
  const formattedData = [];
  if (data) {
    data.forEach((elem) => {
      const { name, mealJson, key, reasonForChange, createdAt } = elem;
      const meal = JSON.parse(mealJson);

      const favoriteObj = {
        name: name,
        description: getMealDescription(meal),
        calories: { ...meal.aboutMeal.Calories },
        protein: { ...meal.aboutMeal.Protein },
        carbohydrates: { ...meal.aboutMeal.Carbs },
        fats: { ...meal.aboutMeal.Fats },
        sugars: { ...meal.aboutMeal.Sugars },
        json: mealJson,
        dateTime: createdAt,
        favoriteId: key,
        reasonForChange: reasonForChange,
      };

      formattedData.push(calculateKcalAndPercentage(favoriteObj));
    });
  }

  return formattedData;
};

const getMealDescription = (meal) => {
  const itemTitles = meal.items.map((item, index) => {
    return index < 2 ? item.title : null;
  });

  let description = itemTitles.filter((title) => title !== null).join(", ");

  if (meal.items.length > 2) {
    description += "...";
  }

  return description;
};

export const mapStateToProps = (state) => {
  return {
    favoriteMeals: getFavoriteMeals(state),
    totalItems: getTotalItems(state),
    searchedParams: getSearchedParams(state),
    canEditFavorites: canEditFavorites(state),
    canViewDetailFavorites: canViewDetailFavorites(state),
    canCreateFavorites: canCreateFavorites(state),
    loading: getLoading(state),
  };
};

export const mapDispatchToProps = {
  fetchFavoriteMeals,
  resetState,
};
